import React from 'react';
import PropTypes from 'prop-types';

class LocationAutocomplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || '',
    };

    this.setValue = this.setValue.bind(this);
  }

  componentDidMount() {
    const { inputId } = this.props;

    const input = document.getElementById(inputId);
    if (input === null) {
      return;
    }

    const geocoder = new window.google.maps.places.Autocomplete(input);
    geocoder.setTypes(['(cities)']);

    window.google.maps.event.addDomListener(input, 'keydown', (e) => {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    });

    geocoder.addListener(
      'place_changed',
      () => {
        this.setValue(input.value);
      },
    );
  }

  setValue(newValue) {
    const { onValueChange } = this.props;
    this.setState({ value: newValue });
    onValueChange(newValue);
  }

  render() {
    const { inputId, value, defaultSample } = this.props;

    return (
      <input
        placeholder={defaultSample}
        type="text"
        id={inputId}
        name={inputId}
        value={value || this.state.value}
        onChange={(e) => this.setValue(e.target.value)}
      />
    );
  }
}

LocationAutocomplete.propTypes = {
  value: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  inputId: PropTypes.string.isRequired,
  defaultSample: PropTypes.string,
};

LocationAutocomplete.defaultProps = {
  value: null,
  defaultSample: null,
};

export default LocationAutocomplete;
